import './App.css';
import { gsap } from 'gsap';
import React, { useRef, useState, useEffect } from 'react';
import AboutPage from './pages/about-page/About-page';
import HomePage from './pages/home-page/Home-page';
import ProjectsPage from './pages/projects-page/Project-page';
import ContactPage from './pages/contact-page/Contact-page';
import ReferenceSection from './pages/reference-section/ReferenceSection';
import logoImage from './assets/new-logo-circle-background-m-square.jpg';
import logoImageGradient from './assets/new-logo-gradient-msize.png';

function App() {
  const [activeSection, setActiveSection] = useState('home');

  const aboutSection = useRef(null);
  const heroSection = useRef(null);
  const projectSection = useRef(null);
  const referenceSection = useRef(null);
  const contactSection = useRef(null);

  const [scrollPosition, setScrollPosition] = useState(0);

  // Funzione per scrollare alle sezioni
  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Funzione per aggiornare la sezione attiva in base alla posizione dello scroll
  const handleScroll = () => {
    const sections = [
      { name: 'home', ref: heroSection },
      { name: 'about', ref: aboutSection },
      { name: 'projects', ref: projectSection },
      { name: 'testimonials', ref: referenceSection },
      { name: 'contact', ref: contactSection },
    ];

    const scrollPos = window.scrollY + window.innerHeight / 2;

    // Trova la sezione corrente in base alla posizione dello scroll
    const currentSection = sections.find(({ ref }) => {
      const sectionTop = ref.current.offsetTop;
      const sectionHeight = ref.current.offsetHeight;
      return scrollPos >= sectionTop && scrollPos < sectionTop + sectionHeight;
    });

    // Aggiorna lo stato della sezione attiva
    if (currentSection && currentSection.name !== activeSection) {
      console.log(currentSection.name)
      setActiveSection(currentSection.name);
    }

    // Aggiorna la posizione dello scroll
    setScrollPosition(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [activeSection]);

  return (
    <>
      {/* Navbar per schermi grandi */}
      <nav
        style={{ transition: 'all ease-in-out 0.5s' }}
        className={scrollPosition > 0 ? 'navbar d-none d-lg-block fixed-top navbar-expand-lg bg-light px-5' : 'navbar d-none d-lg-block fixed-top navbar-expand-lg px-5'}
      >
        <div className="container-fluid">
          <div className="navbar-brand fw-bolder fs-5" to="/">
            <img style={{ height: '50px' }} className="rounded-circle transition" alt="logoLarge" src={scrollPosition > 0 ? logoImageGradient  : logoImage} />
          </div>
          <ul className="navbar-nav mb-lg-0 pointer">
            <li className="nav-item pointer">
              <div className={`nav-link custom-cursor fw-bolder fs-5 pointer-event ${activeSection === 'home' ? 'text-black active-navbar-item' : ''}`} onClick={() => scrollToSection(heroSection)} aria-current="page">
                Home
              </div>
            </li>
            <li className="nav-item">
              <div className={`nav-link custom-cursor fw-bolder fs-5 pointer ${activeSection === 'about' ? 'text-black active-navbar-item' : ''}`} onClick={() => scrollToSection(aboutSection)}>
                About
              </div>
            </li>
            <li className="nav-item">
              <div className={`nav-link custom-cursor fw-bolder fs-5 pointer ${activeSection === 'projects' ? 'text-black active-navbar-item' : ''}`} onClick={() => scrollToSection(projectSection)}>
                Projects
              </div>
            </li>
            <li className="nav-item">
              <div className={`nav-link custom-cursor fw-bolder fs-5 pointer ${activeSection === 'testimonials' ? 'text-black active-navbar-item' : ''}`} onClick={() => scrollToSection(referenceSection)}>
                Testimonials
              </div>
            </li>
            <li className="nav-item">
              <div className={`nav-link custom-cursor fw-bolder fs-5 pointer  ${scrollPosition > 0 ? 'button-primary' : 'text-white'} ${activeSection === 'contact' ? 'contact-active' : ''}` } onClick={() => scrollToSection(contactSection)}>
                Contact Me!
              </div>
            </li>
          </ul>
        </div>
      </nav>

      {/* Navbar per schermi piccoli */}
      <nav
        style={{ transition: 'all ease-in-out 0.5s' }}
        className={scrollPosition > 0 ? 'navbar d-block d-lg-none fixed-top bg-light' : 'navbar d-block d-lg-none bg-transparent fixed-top'}
      >
        <div className="container-fluid">
          <div className="navbar-brand" to="/">
            <img style={{ width: '40px' }} alt="mario" className="rounded-circle" src={logoImage} />
          </div>
          <button className="btn rounded-5" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                <img style={{ height: '50px' }} className="rounded-circle" alt="Small Inside" src={logoImage} />
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div className="offcanvas-body d-flex justify-content-center align-items-center">
              <ul className="navbar-nav justify-content-center pe-3 mb-5">
                <li className="nav-item pointer">
                  <div className="nav-link custom-cursor fw-bolder fs-5 my-4" aria-current="page" data-bs-dismiss="offcanvas" onClick={() => scrollToSection(heroSection)}>
                    Home
                  </div>
                </li>
                <li className="nav-item pointer">
                  <div className="nav-link custom-cursor fw-bolder fs-5 my-4" data-bs-dismiss="offcanvas" onClick={() => scrollToSection(aboutSection)}>
                    About
                  </div>
                </li>
                <li className="nav-item pointer">
                  <div className="nav-link custom-cursor fw-bolder fs-5 my-4" data-bs-dismiss="offcanvas" onClick={() => scrollToSection(projectSection)}>
                    Projects
                  </div>
                </li>
                <li className="nav-item">
                  <div className="nav-link custom-cursor fw-bolder fs-5 my-4" data-bs-dismiss="offcanvas" onClick={() => scrollToSection(referenceSection)}>
                    Testimonials
                  </div>
                </li>
                <li className="nav-item pointer d-flex justify-content-center">
                  <div className="rounded-5 pointer button-primary fw-bolder fs-5 my-4 custom-cursor" data-bs-dismiss="offcanvas" onClick={() => scrollToSection(contactSection)}>
                    Contact Me!
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>

      <HomePage id="heroSection" ref={heroSection} />
      <AboutPage id="aboutSection" ref={aboutSection} />
      <ProjectsPage id="projectSection" ref={projectSection} />
      <ReferenceSection id="referenceSection" ref={referenceSection} />
      <ContactPage id="contactSection" ref={contactSection} />
    </>
  );
}

export default App;